import { isEmpty } from 'lodash-es';
import { JobServeSearch } from 'wisestep-api';

import BasicSearchForm from '../../types/IBasicSearchForm';
import IJobServeAdvanceSearch from '../types/IJobServeAdvanceSearch';

export default function (values: BasicSearchForm & IJobServeAdvanceSearch) {
  const query: JobServeSearch = {
    accountId: values.accountId,
    resultsetPage: values.page + '',
    resultsetSize: values.pageSize + '',
    sortOrder: values.sort,
    keywords: '',
    county: '',
    country: '',
    timePeriod: '',
    locations: '',
    locationTypes: ['Home', 'Preferred', 'Job'],
    distance: '',
    industry: 'IT',
    employmentType: 'Any',
    minSalary: 'Any',
    maxSalary: 'Any',
    visaStatus: '',
    securityClearance: '',
    minEducation: '',
    latestJobTitle: '',
    postCode: '',
    skills: [],
    skillMatch: '',
    skillLevel: '',
    specificDay: '',
  };

  if (values.query) {
    query.keywords = values.query;
  }

  if (values.countrySelect) {
    query.country = values.countrySelect;
  }

  if (values.lastActive) {
    query.timePeriod = values.lastActive;
  }

  if (values.locationString) {
    query.locations = values.locationString;
  }

  if (values.distanceString) {
    query.distance = values.distanceString;
  }

  if (values.locationTypes) {
    query.locationTypes = values.locationTypes;
  }

  if (values.industry) {
    query.industry = values.industry;
  }

  if (values.employmentType) {
    query.employmentType = values.employmentType;
  }

  if (values.minSalary) {
    query.minSalary = values.minSalary;
  }

  if (values.maxSalary) {
    query.maxSalary = values.maxSalary;
  }

  if (values.visaStatus) {
    query.visaStatus = values.visaStatus;
  }

  if (values.securityClearance) {
    query.securityClearance = values.securityClearance.join('|');
  }

  if (values.minEducation) {
    query.minEducation = values.minEducation;
  }

  if (values.latestJobTitle) {
    query.latestJobTitle = values.latestJobTitle;
  }
  if (values.skills && !isEmpty(values.skills)) {
    if (values.skillMatch) {
      query.skillMatch = values.skillMatch;
    }
    if (values.skillLevel) {
      query.skillLevel = values.skillLevel;
    }
    query.skills = values.skills;
  }
  return query;
}
